<template>
  <div class="process-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('process_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-book</v-icon>{{$t('process.documentations')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProcessFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            /> 
          </DataFilter>
          <br />
  
        
          <v-btn icon @click="exportProcesses(selectedIds)"><v-icon>mdi-download</v-icon></v-btn>
          <v-data-table
            v-model="selected"
            show-select
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
            @contextmenu:row="showHandlerExt"
            @input="onSelectionChanged"
          >

          <template slot="item.updated" slot-scope="{ item }">
            {{ formatDateTime(item['updated'], 'long') }}
          </template>
          <template slot="item.types" slot-scope="{ item }">
            <div id="types">
            <v-chip v-for="type in item['types']" :key="type.id"
              class="ma-1 font-weight-bold"

              color="secondary"
            >
              {{ type.name }}
            </v-chip>
          </div>
        </template>
          
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ProcessFilterForm  from '../../components/process/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProcessList',
  servicePrefix: 'Process',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ProcessFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.number'), value: 'number' },
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.namefr'), value: 'namefr' },
        { text: this.$t('global.type'), value: 'types' },
        { text: this.$t('global.update'), value: 'updated' },
        { text: this.$t('global.enabled'), value: 'enabled' },
      ],
      selected: [],
      selectedIds: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('process', {
      items: 'list'
    }),
    ...mapFields('process', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('process', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    ...mapActions({
      processActionDownload: 'process/actionDownload',
    }),
    exportProcesses(selectedIds){
      const ids = selectedIds.map(id => {
      const parts = id.split('/');
      return parseInt(parts[parts.length - 1], 10);
    });
      this.processActionDownload({action: 'exportprocesses', name:'exportprocesses', values: {'idProcesses':JSON.stringify({ids})}});
    },
    onSelectionChanged(selectedItems) {
      this.selected = selectedItems;
      this.selectedIds = selectedItems.map(item => item['@id']);
    }
  }
};
</script>
